module.exports = __webpack_public_path__ + "media/images/home/ic_times-3e7e49c987c23677f8f0b7763c228980.svg";